export function create() {
    const container = document.createElement('div');
    container.classList.add('barba');

    document.body.appendChild(container);
    return container;
}